import React from "react";
import {Page} from "../../../components/page/page";
import styles from "./strong-intuition.module.css";
import Image from "../../../images/couple3.png";
import {useSelector} from "react-redux";

const StrongIntuitionPage = () => {
    const state = useSelector((store) => store.future);

    const buttonStyles = {
        backgroundColor: "rgb(255, 209, 40)",
        border: "1px solid rgb(255, 209, 40)",
        color: "#000000",
        fontSize: '18px',
        boxShadow: 'none',
        borderRadius: '150px',
        position: "absolute",
        bottom: "30px",
        width: "90%",
        zIndex: "5",
        maxWidth: "500px",
        boxSizing: "border-box",
        left: "20px",
        right: "20px"
    };

    const headerStyles = {
        backgroundColor: "transparent",
    }


    return (
        <div className={styles.container_page}>
            <Page title={[<span>{state.gender} {state.zodiacSign}</span>, " often have strong intuition & trust"]}
                  nextPageLink="../additional-goals" buttonStyles={buttonStyles} currentStep="15" headerStyles={headerStyles} isWhiteLogo={true} isWhiteButton={true}>
                <p className={styles.text}>
                    This shows you are very likely to build a <span>strong, lasting and passionate relationship.</span>
                </p>
                <img className={styles.couple_image} src={Image} alt=""/>
            </Page>
        </div>
    );
}

export {StrongIntuitionPage};